import _taggedTemplateLiteral from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _asyncToGenerator from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _templateObject, _templateObject2;
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
import React from "react";
import { FORM_ERROR } from "final-form";
import { Form as FinalForm, FormSpy } from "react-final-form";
import createFocusDecorator from "final-form-focus";
import setFieldData from "final-form-set-field-data";
import arrayMutators from "final-form-arrays";
import styled from "@emotion/styled";
import { prop } from "styled-tools";
import { Text } from "@rebass/emotion";
import debounce from "lodash/debounce";
import { pickProps, normalizeErrors } from "@edenlabllc/ehealth-utils";
import Button from "./Button";
import Heading from "./Heading";
var FINAL_FORM_PROPS = ["debug", "decorators", "initialValues", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"];
var focusOnErrors = createFocusDecorator();
var Form = function Form(_ref) {
  var innerRef = _ref.innerRef,
    errorPosition = _ref.errorPosition,
    props = _objectWithoutProperties(_ref, ["innerRef", "errorPosition"]);
  var _pickProps = pickProps(props, FINAL_FORM_PROPS),
    _pickProps2 = _slicedToArray(_pickProps, 2),
    _pickProps2$ = _pickProps2[0],
    _pickProps2$$decorato = _pickProps2$.decorators,
    decorators = _pickProps2$$decorato === void 0 ? [] : _pickProps2$$decorato,
    mutators = _pickProps2$.mutators,
    onSubmit = _pickProps2$.onSubmit,
    finalFormProps = _objectWithoutProperties(_pickProps2$, ["decorators", "mutators", "onSubmit"]),
    formProps = _pickProps2[1];
  return /*#__PURE__*/React.createElement(FinalForm, Object.assign({
    decorators: [focusOnErrors].concat(_toConsumableArray(decorators)),
    mutators: _objectSpread({
      setFieldData: setFieldData
    }, arrayMutators, mutators),
    subscription: {},
    onSubmit: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return onSubmit.apply(void 0, _args);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            if (!Array.isArray(_context.t0.graphQLErrors)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", normalizeErrors(_context.t0.graphQLErrors));
          case 12:
            return _context.abrupt("return", _context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }))
  }, finalFormProps), function (_ref3) {
    var handleSubmit = _ref3.handleSubmit;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", Object.assign({}, formProps, {
      ref: innerRef,
      onSubmit: handleSubmit,
      method: "POST"
    })), /*#__PURE__*/React.createElement(NonExistentInputError, {
      errorPosition: errorPosition
    }));
  });
};
export var FormButton = function FormButton(props) {
  return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
    type: props.to || props.href ? undefined : "button"
  }, props));
};
export var FormSubmit = function FormSubmit(_ref4) {
  var disabled = _ref4.disabled,
    props = _objectWithoutProperties(_ref4, ["disabled"]);
  return /*#__PURE__*/React.createElement(FormSpy, {
    subscription: {
      submitting: true
    }
  }, function (_ref5) {
    var submitting = _ref5.submitting;
    return /*#__PURE__*/React.createElement(FormButton, Object.assign({}, props, {
      disabled: disabled || submitting,
      type: "submit"
    }));
  });
};
export var FormError = function FormError(_ref6) {
  var _ref6$entry = _ref6.entry,
    entry = _ref6$entry === void 0 ? "$.data" : _ref6$entry,
    props = _objectWithoutProperties(_ref6, ["entry"]);
  return /*#__PURE__*/React.createElement(FormSpy, {
    subscription: {
      submitErrors: true
    }
  }, function (_ref7) {
    var submitErrors = _ref7.submitErrors;
    if (!submitErrors) return null;
    var invalid = submitErrors[SUBMIT_ERROR];
    if (!invalid) return null;
    var item = invalid.find(function (i) {
      return entry ? Object.keys(entry).includes(i.entry) : null;
    });
    var result;
    if (!item) {
      result = props.default;
    } else {
      var rulesMatch = item.rules ? item.rules : invalid.reduce(function (prev, item) {
        return [].concat(_toConsumableArray(prev), _toConsumableArray(item.rules));
      }, []);
      var match = rulesMatch.find(function (_ref8) {
        var rule = _ref8.rule;
        return Object.keys(entry["".concat(item["entry"])]).includes(rule);
      });
      if (!match) {
        result = entry["".concat(item["entry"])]["default"] ? entry["".concat(item["entry"])]["default"] : props.default;
      } else {
        result = item.rules ? entry["".concat(item["entry"])]["".concat(match["rule"])] : props.default;
      }
    }
    return /*#__PURE__*/React.createElement(ErrorContentHolder, null, /*#__PURE__*/React.createElement(Heading.H3, null, /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, result)));
  });
};
export var NonExistentInputError = function NonExistentInputError(_ref9) {
  var _ref9$errorPosition = _ref9.errorPosition,
    errorPosition = _ref9$errorPosition === void 0 ? "left" : _ref9$errorPosition;
  return /*#__PURE__*/React.createElement(FormSpy, {
    subscription: {
      submitErrors: true
    }
  }, function (_ref10) {
    var submitErrors = _ref10.submitErrors,
      form = _ref10.form;
    if (!submitErrors) return null;
    var renderedFormFields = form.getRegisteredFields();
    var uniqueFieldsWithError = Object.keys(submitErrors).filter(function (erroredField) {
      return !renderedFormFields.includes(erroredField);
    });
    return /*#__PURE__*/React.createElement(Heading.H4, {
      textAlign: errorPosition,
      mb: 4
    }, uniqueFieldsWithError.map(function (field, key) {
      return /*#__PURE__*/React.createElement(Text, {
        color: "red",
        key: key
      }, submitErrors[field].message);
    }));
  });
};
export var FormAutoSubmit = function FormAutoSubmit(_ref11) {
  var _ref11$delay = _ref11.delay,
    delay = _ref11$delay === void 0 ? 500 : _ref11$delay,
    onSubmit = _ref11.onSubmit;
  var onSubmitDebounced = debounce(onSubmit, delay);
  return /*#__PURE__*/React.createElement(FormSpy, {
    subscription: {
      values: true
    },
    onChange: function onChange(_ref12) {
      var values = _ref12.values;
      return onSubmitDebounced(values);
    }
  });
};
export var FormSpyWrapper = function FormSpyWrapper(props) {
  return /*#__PURE__*/React.createElement(FormSpy, Object.assign({}, props, {
    render: function render(renderProps) {
      return props.children ? props.children(renderProps) : null;
    }
  }));
};
Form.Spy = FormSpyWrapper;
Form.Button = FormButton;
Form.Submit = FormSubmit;
Form.AutoSubmit = FormAutoSubmit;
Form.Error = FormError;
export default Form;
export var SUBMIT_ERROR = FORM_ERROR;
var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), prop("theme.form.fieldVerticalDistance", 20));
var ErrorContentHolder = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: left;\n  font-size: 14px;\n  margin: 14px 0;\n"])));